import React, { Component } from 'react';
import Vas from '../Vas';

import { LinkButton } from 'component-lib';

class ResetPasswordSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        return ( <div className="LoginContainer">
          <div
            className={"form"}
            style={{ width:'400px' }}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["ResetPasswordSuccess"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width:'120px', fontSize:'14px', float: 'right', textAlign: 'right' }}>{Vas.Resources.Labels["LinkLogin"]}</td>
                  <td style={{ textAlign: 'left' }}>
                    <LinkButton
                    Text={Vas.Resources.Menus["Login"]}
                    Id={"LinkLogin"}
                    OnClick={()=>{Vas.GetView("Login");}} /></td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default ResetPasswordSuccess;
